module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('h2', {
    staticClass: "tocli"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocli"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocli"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_introduction"
    }
  }, [_vm._v("Introduction by Dan Brookes")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocli"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_chapter_01"
    }
  }, [_vm._v("A Life-Changing Experience by Bob Hillerby")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Million-Dollar Experience by Dan Brookes")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons Not Learned – My Lai Revisited")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of a US Army Combat Correspondent")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vietnam Was Also a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Country")]), _vm._v(" – Photographs of a People and a Culture")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parting Shots – Afterword")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0